import { useEffect, useRef } from 'react';

const useDebounce = <T>(callback: (...args: T[]) => void, delay: number) => {
    const timeoutRef = useRef(null);

    useEffect(() => {
        // Cleanup the previous timeout on re-render
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (...args) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            callback(...args);
        }, delay);
    };
};

export default useDebounce;
